import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {$accountFactory} from "../../$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {MetaDataModel} from "../../../commons/models/meta-data.model";
import {Service} from "../../../deliveries/models/service.model";
import {AccountsService} from "../../services/accounts-service.service";

export class ShipperAccountPreferencesCtrl implements IController {

  account: AccountModel;
  metaData?: any;

  public documentsIdentifierTypes: string[];
  public dynamicColumnsMap: any;
  public editableMetaData?: MetaDataModel;
  private accountCopy: any;
  private accountRef: any;
  private languages: any;
  private serviceTypes: any;
  private canUpdate: any;
  private isSaveAvailable: boolean;

  constructor(private $account: $accountFactory, private IAMPermissions, private accountsAlerts: AccountsAlerts, private accountsService: AccountsService,
              private commonsDialogService: CommonsDialogService, private $log, private splitConstants, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.documentsIdentifierTypes = ['ORDER_ID', 'EXTERNAL_ID', 'PRO_NUMBER'];

    this.canUpdate = this.IAMPermissions.hasPermission('accounts.demand.update');

    // Languages
    this.languages = this.splitConstants.languages;

    // Init Account Bringoz Object By Account Id.
    this.accountRef = this.$account(this.account.id);

    this.serviceTypes = [];

    if (!this.account.pastDateServiceSettings) {
      this.account.pastDateServiceSettings = {};
    }

    this.accountCopy = angular.copy(this.account);

    this.dynamicColumnsMap = _.mapKeys(this.account.metaData, (value, key) => {
      return value.key;
    });

  };

  onElementPopUp(event, header, type, key, value) {
    this.commonsDialogService.preferencesValue(event, header, value, type)
      .then((updatedValue) => {
        this.account[key] = updatedValue;
        this.onUpdate();
      })
      .catch(() => {
        this.$log.info('Closed Dialog');
      })
  }

  onChangeContacts(contacts) {
    this.account.contactPeople = angular.copy(contacts);
    this.onUpdate();
  }

  onUpdateEnableSms(value) {
    this.account.enableSms = value;
    this.onUpdate();
  }

  onUpdateEnableEmail(value) {
    this.account.enableEmail = value;
    this.onUpdate();
  }

  onUpdate() {
    this.isSaveAvailable = !_.isEqual(this.account, this.accountCopy);
  }

  onSave(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this._updateAccount();
      }
    }
  }

  onCancelChanges() {
    this.account = angular.copy(this.accountCopy);
    this.onUpdate();
  }

  onEditMetaData(key: string, value?: string) {
    this.editableMetaData = {key: key, value: value};
  }

  onCancelEditMetaData() {
    this.editableMetaData = undefined;
  }

  onEditableMetaDataValueChange(value) {
    this.editableMetaData.value = value;
  }

  onSaveMetaData(editableMetaData: { key: string, value: string }) {
    const metaDataCopy = angular.copy(this.account.metaData) || [];
    const metaDataIndex = metaDataCopy.findIndex((m: { key: string, value?: string }) => {
      return m.key === editableMetaData.key;
    })
    if (metaDataIndex > -1) {
      metaDataCopy[metaDataIndex] = editableMetaData;
    } else {
      metaDataCopy.push(editableMetaData);
    }
    this._updateMetaData(metaDataCopy)
  }

  private _updateMetaData(metaData: MetaDataModel[]) {
    this.accountsService.updateMetaData(this.account.id, metaData)
      .then((updatedService: Service) => {
        this.dynamicColumnsMap = _.mapKeys(updatedService.metaData, (value, key) => {
          return value.key;
        });
        this.editableMetaData = undefined;
      })
  }

  private _updateAccount() {
    this.bringozLoaderService.on();
    this.accountRef.$update(this.account)
      .then((updatedAccount) => {
        this.isSaveAvailable = false;
        this.account = updatedAccount;
        this.accountCopy = angular.copy(updatedAccount);
        this.accountsAlerts.demandUpdateSuccess();
      })
      .catch((error) => {
        this.accountsAlerts.demandUpdateError();
        this.$log.error('Failed to update account @shipperAccountPreferences@onSave', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountPreferences', {
    bindings: {
      account: '<',
      metaData: '<?'
    },
    template: require('./shipper-account-preferences.html').default,
    controller: ShipperAccountPreferencesCtrl
  });
